/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/healthcheck": {
    get: operations["GetApiHealthcheck"];
  };
  "/api/v3/auth/signup": {
    post: operations["PostApiV3AuthSignup"];
  };
  "/api/v4/user": {
    get: operations["GetApiV4User"];
  };
  "/api/v4/user/onboarding": {
    post: operations["PostApiV4UserOnboarding"];
  };
}

export interface components {
  schemas: {
    AlternativeContact: {
      /** @enum {string} */
      type:
        | "none"
        | "skype"
        | "telegram"
        | "facebook"
        | "whatsapp"
        | "qq"
        | "viber"
        | "wechat"
        | "weibo"
        | "email";
      value: string;
    };
    /** @enum {string} */
    EnumUserLegalType: "legal" | "individual";
    /** @enum {string} */
    EnumUserProgram: "affiliate" | "ib";
    /** @enum {string} */
    EnumUserType: "affiliate" | "employee";
    Error: {
      error?: components["schemas"]["ErrorItem"];
    };
    ErrorField: {
      /** @description translation key of error */
      key?: string;
      params?: { [key: string]: string };
    };
    /**
     * @example {
     *   "_global": {
     *     "key": "api_error.rate_limit",
     *     "params": {
     *       "until": 1551908007642
     *     }
     *   },
     *   "fields": {
     *     "name": {
     *       "key": "api_error.validation_is_int",
     *       "params": {
     *         "value": "whatever was passed as non int"
     *       }
     *     }
     *   }
     * }
     */
    ErrorItem: {
      _global?: components["schemas"]["ErrorField"];
      fields?: { [key: string]: components["schemas"]["ErrorField"] };
    };
    HealthcheckResponse: {
      alive: boolean;
    };
    Manager: {
      alt_contact: components["schemas"]["AlternativeContact"][];
      first_name: string;
      /** Format: int64 */
      id: number;
      is_online: boolean;
      last_name?: string;
      leave?: {
        /** Format: date-time */
        from: string;
        /** @enum {string} */
        leave_type: "none" | "trip" | "vacation" | "sick" | "holidays";
        /** Format: date-time */
        to: string;
      };
      photo?: string;
      working_hours: {
        from: string;
        timezone: string;
        to: string;
      };
    };
    OnboardingPost: {
      alt_contact: components["schemas"]["AlternativeContact"][];
      country_code: string;
      legal_profile:
        | components["schemas"]["UserProfileLegal"]
        | components["schemas"]["UserProfileIndividual"];
      /** @enum {string} */
      monthly_leads_count?: "gte1" | "gte3" | "gte11" | "gte100";
      partnership_experience?: string;
      program: components["schemas"]["EnumUserProgram"];
      support_language: string;
      traffic_regions: string;
      traffic_sources: string;
      /** @enum {string} */
      working_experience: "yes" | "no";
    };
    Signup: {
      aff_track?: string;
      email: string;
      is_agreement_signed: boolean;
      /** @description for internal usage */
      keyword?: string;
      password: string;
      preferable_lang: string;
      /**
       * Format: int64
       * @description for referral system
       */
      ref_account_id?: number;
      /** @description user referrer url */
      referrer?: string;
      site: string;
      /** @description for internal usage */
      source?: string;
    };
    SignupResponse: {
      /** Format: int64 */
      id: number;
    };
    UserProfile: {
      alt_contact: components["schemas"]["AlternativeContact"][];
      /** Format: date */
      birthdate?: string;
      country_code: string;
      email: string;
      /** Format: int64 */
      id: number;
      is_agreement_signed: boolean;
      is_confirmed: boolean;
      is_doc_verified: boolean;
      is_onboarding_passed: boolean;
      is_phone_confirmed: boolean;
      is_subscribed_to_news: boolean;
      legal_profile:
        | components["schemas"]["UserProfileLegal"]
        | components["schemas"]["UserProfileIndividual"];
      manager?: components["schemas"]["Manager"];
      nick_name?: string;
      phone: string;
      program: components["schemas"]["EnumUserProgram"];
      /** Format: date-time */
      registered_at: string;
      site_id: number;
      subaffiliate_percent: number;
      support_language: string;
      ui_language: string;
      user_type: components["schemas"]["EnumUserType"];
    };
    UserProfileIndividual: {
      first_name: string;
      last_name: string;
      legal_type: components["schemas"]["EnumUserLegalType"];
    };
    UserProfileLegal: {
      company_name: string;
      legal_type: components["schemas"]["EnumUserLegalType"];
      representative_first_name: string;
      representative_last_name: string;
    };
  };
}

export interface operations {
  GetApiHealthcheck: {
    responses: {
      /** Successful operation with token in cookie */
      200: {
        content: {
          "application/json": components["schemas"]["HealthcheckResponse"];
        };
      };
      /** Unexpected Error */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      500: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiV3AuthSignup: {
    responses: {
      /** Successful operation */
      201: {
        content: {
          "application/json": components["schemas"]["SignupResponse"];
        };
      };
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["Signup"];
      };
    };
  };
  GetApiV4User: {
    responses: {
      /** Successful operation */
      200: {
        content: {
          "application/json": components["schemas"]["UserProfile"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiV4UserOnboarding: {
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["OnboardingPost"];
      };
    };
  };
}

export interface external {}

export enum ApiPaths {
  GetApiHealthcheck = "/api/healthcheck",
  PostApiV3AuthSignup = "/api/v3/auth/signup",
  GetApiV4User = "/api/v4/user",
  PostApiV4UserOnboarding = "/api/v4/user/onboarding",
}
